/** Admin mentés — pricing-config seller_services_page mező. */
export function buildSellerServicesPagePayload(page) {
  const p = page || {};
  return {
    hero_title: String(p.hero_title ?? ""),
    hero_lead: String(p.hero_lead ?? ""),
    cta_primary_label: String(p.cta_primary_label ?? ""),
    cta_primary_path: String(p.cta_primary_path ?? ""),
    cta_secondary_label: String(p.cta_secondary_label ?? ""),
    cta_secondary_path: String(p.cta_secondary_path ?? ""),
    sections: (p.sections || []).map((s, i) => ({
      id: s.id || `svc_${i}_${Date.now()}`,
      title: String(s.title || "").trim(),
      tagline: String(s.tagline || ""),
      body: String(s.body || ""),
      addon_key: String(s.addon_key || ""),
      billing: s.billing || "none",
      published: s.published !== false,
      sort_order: Number(s.sort_order ?? i * 10),
    })),
  };
}
